import { Stack } from "@mui/material";
import { CustomTextView } from "../../../component/CustomTextView";
import { useTranslation } from "react-i18next";
import { LoadingView } from "../../../component/LoadingView";
import { CustomButtonView } from "../../../component/CustomButtonView";
import { COLOR_MAIN } from "../../../../data/colors/Colors";
import { CustomImageView } from "../../../component/CustomImageView";

export function CharadesCategoryView({
  onReadyButtonClicked,
  qrCodeImageUrl,
  isCharadesReadyToPlay,
  isMobile,
}: {
  onReadyButtonClicked: () => void;
  qrCodeImageUrl: string | undefined;
  isCharadesReadyToPlay: boolean;
  isMobile: boolean;
}) {
  const { t } = useTranslation();
  return (
    <Stack
      height={"100%"}
      justifyContent={"space-between"}
      alignItems={"center"}
    >
      <CustomTextView
        text={t("choose_player_qr_code")}
        fontWeight="bold"
        textColor="white"
        variant={isMobile ? "h6" : "h4"}
        textAlign="center"
      />
      {qrCodeImageUrl ? (
        <CustomImageView
          src={qrCodeImageUrl}
          width={isMobile ? 140 : 200}
          height={isMobile ? 140 : 200}
        />
      ) : (
        <LoadingView minHeight="10vh" color="white" />
      )}
      {!isCharadesReadyToPlay && (
        <Stack width={"100%"}>
          <CustomButtonView
            onClick={onReadyButtonClicked}
            text={t("ready")}
            textColor={COLOR_MAIN}
            backgroundColor="white"
            fontSize={isMobile ? "h6" : "h5"}
          />
        </Stack>
      )}
    </Stack>
  );
}
